import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { RecordSgm } from '../data';
import { v4 as uuidv4 } from 'uuid';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { SgmService } from '../../../../services/sgm/sgm.service';

import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';

type Row = {
  id: string;
  audit_objective: string;
  results: { title: string; discovery: string; observation: string }[],
  conclusion: string;
  auditors: { name: string; area: string; process: string }[];
  audit_developments: { date: string | Date; hour: string; activity: string; auditor: string; element: string }[];
  discoveries: { type: string; total: string; }[];
}

const titles = [
  'POLÍTICA',
  'IDENTIFICACIÓN RIESGOS ASOCIADOS AL SGM',
  'REQUISITOS LEGALES',
  'OBJETIVOS DE CALIDAD',
  'CAPACITACIÓN Y ENTRENAMIENTO',
  'CONTROL DE DOCUMENTOS Y REGISTROS',
  'EQUIPOS DE MEDICIÓN',
  'EVALUACIÓN DE PROVEEDORES',
  'ACCIONES PREVENTIVAS Y DE MEJORA',
  'ACCIONES CORRECTIVAS',
  'AUDITORÍAS',
  'CONFIRMACIÓN METROLÓGICA',
  'ATENCIÓN DE QUEJAS'
]

const emptyForm: Row = {
  id: '',
  audit_objective: '',
  results: titles.map(title => ({ title, discovery: '', observation: '' })),
  conclusion: '',
  auditors: [],
  audit_developments: [],
  discoveries: [],
}

@Component({
  selector: 'ngx-sgm-formato-diezysiete',
  templateUrl: './formato-diezysiete.component.html',
})
export class FormatoDiezysieteComponent implements OnInit {
  @Input() stationId: string;
  @Input() user: { role: string };
  @Input() record: RecordSgm;
  @Output() recordChange = new EventEmitter<Partial<RecordSgm & { row: any, event: string }> >();
  source: LocalDataSource;
  row = { ...emptyForm }
  loading = false
  settings = {
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'download',
          title: '<img src="assets/images/icons/download.png" width="25px">',
        },
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      audit_objective: {
        title: 'Objetivo y Alcance de la Auditoría',
        filter: true,
      },
      conclusion: {
        title: 'Conclusiones',
        filter: true,
      }
    },
    noDataMessage: 'Sin registros',
  };

  constructor(private sgmService: SgmService) {}

  ngOnInit() {
    if (this.user.role === 'viewAndDownloadOnly') {
      this.settings.actions.custom = [
        {
          name: 'download',
          title: '<img src="assets/images/icons/download.png" width="25px">',
        },
      ];
    }
    this.loadData()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.record.currentValue.rows) {
      this.source = new LocalDataSource(changes.record.currentValue.rows)
    }
  }

  async onCustom(event: { action: string; data: Row; }) {
    this.row = event.data;
    if (event.action === 'delete') {
      // @ts-ignore
      $('#delete-document').modal('show');
    } else if (event.action === 'edit') {
      // @ts-ignore
      $('#create-document').modal('show');
    } else if (event.action === 'download') {
      this.download();
    }
  }

  async remove () {
    this.recordChange.emit({ ...this.record, rows: [], row: this.row, event: 'delete' })
    this.record.rows = this.record.rows.filter(row => row.id !== this.row.id)
    this.loadData()
    // @ts-ignore
    $('#delete-document').modal('hide');
  }

  async storeOrUpdate () {
    this.recordChange.emit({ ...this.record, rows: [], row: this.row, event: this.row.id ? 'edit' : 'create' })
    this.loadData()
    // @ts-ignore
    $('#create-document').modal('hide');
  }

  loadData () {
    this.row = { ...emptyForm };
    this.source = new LocalDataSource(this.record.rows)
  }

  addAudit () {
    this.row.auditors.push({ name: '', area: '', process: '' })
  }

  addAuditDevelopment () {
    this.row.audit_developments.push({ date: '', hour: '', activity: '', auditor: '', element: '' })
  }

  addDiscovery () {
    this.row.discoveries.push({ type: '', total: '' })
  }

  removeToArray (index: number, rows: Array<any>) {
    rows.splice(index, 1)
  }

  async download () {
    await this.sgmService.downloadFormat({
      stationId: this.stationId,
      category: this.record.category,
      file: this.record.key,
      id_item: this.row.id
    });
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}


